import {
  CommercialIndustrialRoutes,
  HdbResaleRoutes,
  OthersRoutes,
  PrivateResaleRoutes,
  Routes,
} from './routes';
import { HDB_SALES_PROCEEDS_TRACKING } from './tracking';

export const SCREEN_VIEW_GA = 'screen_view';
export const SELECT_CONTENT_GA = 'select_content';
export const SELECT_ITEM_GA = 'select_item';

export const getPageKey = (pathName: string) => {
  switch (pathName) {
    case Routes.COMMERCIAL_INDUSTRIAL + CommercialIndustrialRoutes.RESALE_VS_BUC: {
      return 'commercial_industrial_resale_vs_buc';
    }
    case Routes.COMMERCIAL_INDUSTRIAL + CommercialIndustrialRoutes.PURCHASE_RESALE: {
      return 'commercial_industrial_purchase';
    }
    case Routes.COMMERCIAL_INDUSTRIAL + CommercialIndustrialRoutes.INVESTMENT: {
      return 'commercial_industrial_investment';
    }
    case Routes.COMMERCIAL_INDUSTRIAL + CommercialIndustrialRoutes.SALES_PROCEEDS: {
      return 'commercial_industrial_sales_proceeds';
    }
    case PrivateResaleRoutes.PURCHASE_RESALE:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.PURCHASE_RESALE: {
      return 'private_residential_purchase_resale';
    }
    case PrivateResaleRoutes.SALES_PROCEEDS:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.SALES_PROCEEDS: {
      return 'private_residential_sales_proceeds';
    }
    case PrivateResaleRoutes.BUYER_STAMP_DUTY:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.BUYER_STAMP_DUTY:
    case Routes.OTHERS + OthersRoutes.BUYER_STAMP_DUTY: {
      return 'private_residential_iras_stamp_duty';
    }
    case PrivateResaleRoutes.TDSR:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.TDSR: {
      return 'private_residential_tdsr';
    }
    case PrivateResaleRoutes.RENTAL_YIELD:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.RENTAL_YIELD:
    case Routes.COMMERCIAL_INDUSTRIAL + PrivateResaleRoutes.RENTAL_YIELD: {
      return 'rental_yield';
    }
    case Routes.OTHERS + OthersRoutes.MORTGAGE_LOAN: {
      return 'others_mortgage_loan';
    }
    case Routes.OTHERS + OthersRoutes.PART_SHARE_PURCHASE: {
      return 'others_part_share_purchase';
    }
    case Routes.OTHERS + OthersRoutes.EQUITY_TERM_LOAN: {
      return 'others_equity_term_loan';
    }
    case Routes.OTHERS + OthersRoutes.RENTAL_STAMP_DUTY: {
      return 'others_rental_stamp_duty';
    }
    case Routes.OTHERS + OthersRoutes.PLEDGE_UNPLEDGE: {
      return 'others_pledge_unpledge';
    }
    case Routes.HDB_RESALE + HdbResaleRoutes.SALES_PROCEEDS: {
      return HDB_SALES_PROCEEDS_TRACKING.ENTRY_POINT;
    }
    case Routes.OTHERS + OthersRoutes.MSR: {
      return 'others_msr';
    }
    case Routes.OTHERS + OthersRoutes.CPF_USAGE: {
      return 'analytics_cpf_usage';
    }
    case Routes.HDB_RESALE + HdbResaleRoutes.MSR: {
      return 'hdb_resale_msr';
    }
    case Routes.HDB_RESALE + HdbResaleRoutes.PURCHASE: {
      return 'analytics_hdb_resale_purchase_resale';
    }
    case PrivateResaleRoutes.PURCHASE_NEW_PROJECT:
    case Routes.PRIVATE_RESALE + PrivateResaleRoutes.PURCHASE_NEW_PROJECT: {
      return 'analytics_private_resale_purchase_new_project';
    }

    default: {
      return '';
    }
  }
};
